import request from '@/config/axios'

// ========== 枚举定义 ==========

/** 生肖五行 → el-tag 类型（金=warning 木=success 水=primary 火=danger 土=info） */
export const WX_TAG_TYPES: Record<string, 'warning' | 'success' | 'primary' | 'danger' | 'info'> = {
  金: 'warning',
  木: 'success',
  水: 'primary',
  火: 'danger',
  土: 'info'
}

// ========== VO ==========

/** 生肖档案 VO */
export interface ZodiacVO {
  id?: number
  name?: string
  /** 只读：地支（子/丑/寅/...，后端维护，不可改） */
  branch?: string
  /** 只读：五行（金/木/水/火/土，后端维护，不可改） */
  wx?: string
  /** 只读：方位（后端维护，不可改） */
  pos?: string
  personality?: string
  merit?: string
  attention?: string
  keywords?: string
  iconUrl?: string
  sort?: number
  status?: number
}

/** 生肖档案更新 SaveReqVO（name/branch/wx/pos 不可改，仅传可编辑字段） */
export interface ZodiacSaveReqVO {
  id: number
  personality?: string
  merit?: string
  attention?: string
  keywords?: string
  iconUrl?: string
  sort?: number
  status?: number
}

/** 生肖精简信息 VO */
export interface ZodiacSimpleVO {
  id: number
  name: string
  iconUrl?: string
  status?: number
}

// ========== 生肖档案 ==========

export const ZodiacApi = {
  // 查询生肖档案分页
  getPage: (params: PageParam) => {
    return request.get({ url: '/xuanxue/zodiac/page', params })
  },
  // 查询生肖档案详情（含全字段）
  get: (id: number) => {
    return request.get({ url: '/xuanxue/zodiac/get?id=' + id })
  },
  // 修改生肖档案（仅可编辑字段：personality/merit/attention/keywords/iconUrl/sort/status）
  update: (data: ZodiacSaveReqVO) => {
    return request.put({ url: '/xuanxue/zodiac/update', data })
  },
  // 修改生肖档案状态
  updateStatus: (id: number, status: number) => {
    return request.put({ url: '/xuanxue/zodiac/update-status', params: { id, status } })
  },
  // 获取生肖精简列表
  getSimpleList: async (): Promise<ZodiacSimpleVO[]> => {
    return await request.get({ url: '/xuanxue/zodiac/simple-list' })
  }
}
